import { render, staticRenderFns } from "./CEduQuiz.vue?vue&type=template&id=38a28178"
import script from "./CEduQuiz.vue?vue&type=script&lang=js"
export * from "./CEduQuiz.vue?vue&type=script&lang=js"
import style0 from "./CEduQuiz.vue?vue&type=style&index=0&id=38a28178&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a28178')) {
      api.createRecord('38a28178', component.options)
    } else {
      api.reload('38a28178', component.options)
    }
    module.hot.accept("./CEduQuiz.vue?vue&type=template&id=38a28178", function () {
      api.rerender('38a28178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CEduQuiz.vue"
export default component.exports